module.exports = __webpack_public_path__ + "static/media/wacey.6ace6087.gif";